import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useContext,
} from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
//@components
import { X } from "react-feather";
import NoData from "../../../Pages/InformativeComponents/NoData.component";
import Assetversionslist from "../AssetVersionsList/Assetversionslist.component";
import AssetVersionsTools from "../AssetVersionsTools/AssetVersionsTools.component.jsx";
import AssetVersionNewVersionModal from "../AssetsVersionsPageModal/AssetVersionNewVersionModal";
import { MovieColabContext } from "../../../Context/MovieColabContext";
import { selectAppliedFilterForTrackable } from "../../../redux/selectors/projectFilters";

//@MUI
import {
  Box,
  Divider,
  Modal,
  Slide,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";

import useStyles from "./AssetversionsOverview.styles";

import { Alert } from "@material-ui/lab";
import {
  fget,
  fpatch,
  fpost,
  fpostBFF,
  uploadFile,
} from "../../../API/callsAPI";
import CanvasFrame from "../../CanvasFrame/CanvasFrame.component";
import AssetAndShotVersionTimeline from "../../Utilities/AssetAndShotVersionTimeline/AssetAndShotVersionTimeline.jsx";
import CustomPagination from "../../Utilities/CustomPagination/CustomPagination.component";
import Loader from "../../Utilities/Loader/Loader";
import NewDataLoadingLoader from "../../Utilities/NewDataLoadingLoader/NewDataLoadingLoader.component";
import { StatusRearrange } from "../../Utilities/StatusRearrange/StatusRearrange";
import UpdateParentAssetOrShootThumbnailModal from "../../Utilities/UpdateParentAssetOrShootThumbnail/UpdateParentAssetOrShootThumbnailModal";
import VersionFilterModal from "../../Utilities/VersionFilterModal/VersionFilterModal";
import VersionViewerOverview from "../../Utilities/VersionViewer/VersionViewerOverview/VersionViewerOverview";
import ExportModal from "../../Utilities/ExportModal/ExportModal";
import CSVImportModal from "../../Utilities/CSVImportModal/CSVImportModal";
import { mapFieldsFromConfig } from "../../Utilities/CustomTableForAllTrackables/fieldMapper.js";
import AssetVersionCustomTable from "../AssetVersionsTable/AssetVersionCustomTable.jsx";
import AssetVersionDefaultTable from "../AssetVersionsTable/AssetVersionDefaultTable.jsx";

function AssetVersionsOverview(props) {
  const history = useHistory();
  const classes = useStyles();
  const tableRef = useRef();

  const [assetVersionList, setAssetVersionList] = useState();
  const [parentAsset, setParentAsset] = useState();
  const [assetVersionFilteredStatus, setAssetVersionFilteredStatus] =
    useState("");
  const [versionFromURL, setVersionFromURL] = useState(); //open versionDetailModal if id present in url
  const [trackableClass, setTrackableClass] = useState([]);
  const [allUsersName, setAllUsersName] = useState();
  const [statusList, setStatusList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoaded, setIsLoaded] = useState(false);
  const [sortByDefault, setSortByDefault] = useState("");
  const [isAssetTogglerOn, setIsAssetTogglerOn] = useState(false);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [commentsRefreshCounter, setCommentsRefreshCounter] = useState(0);
  const [isNewAssetVerisonModalOpen, setNewAssetVersionModalOpen] =
    useState(false);
  const [isAssetDetailModalOpen, setAssetDetailModalOpen] = useState(false);
  const [selectedAssetVersion, setSelectedAssetVersion] = useState();
  const [isUpdateParentAssetModalOpen, setUpdateParentAssetModalOpen] =
    useState(false);
  const [updatedFileForParent, setUpdatedFileForParent] = useState();
  const [snackValue, setSnackValue] = React.useState({
    isOpen: false,
    message: "",
    isError: false,
  });
  const [canvasModal, setCanvasModal] = useState(false);
  const [imageRef, setImageRef] = useState(null);
  const [screenshot, setScreenshot] = useState(null);
  const [playerProgress, setPlayerProgress] = useState("00:00");

  const [dragScreen, setDragScreen] = useState(false);
  //state will be true when we start drag file inside modals
  const [dragFileEnterModal, setDragFileEnterModal] = useState(false);
  // to store tasks of the current trackable
  const [taskList, setTaskList] = useState([]);
  // state for opening fullscreen viewer of version viewer file
  const [isOpenFullscreenViewer, setIsOpenFullscreenViewer] = useState(false);
  const [fileForFullscreenViewer, setFileForFullscreenViewer] = useState(null);
  const [scrollValue, setScrollValue] = useState("");
  const [updateOnPageChange, setUpdateOnPageChange] = useState(0);
  const [commentId, setCommentId] = useState("");
  //statuslist of status linked with task
  const [taskStatusList, setTaskStatusList] = useState([]);
  const [isNewPageLoading, setIsNewPageLoading] = useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [assetVersionStats, setAssetVersionStats] = useState({
    total: 0,
    visibleCount: 0,
  });
  const [filterValues, setFilterValues] = useState({
    status: "",
    task: "",
  });
  const [filterButtonActive, setFilterButtonActive] = useState(false);
  const [commentsPageNo, setCommentsPageNo] = useState(1);
  const [isTimeLineModalOpen, setIsTimeLineModalOpen] = useState(false);
  const [commentFilter, setCommentFilter] = useState("-created_at");
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [openBulkImportModal, setOpenBulkImportModal] = useState(false);
  const [allFieldsConfig, setAllFieldsConfig] = useState([]);
  const [isToggleView, setIsToggleView] = useState(false);
  const hadAppliedFilterRef = useRef(false);
  const { trackableClass: contextTrackableClass } =
    useContext(MovieColabContext);
  const assetVersionTrackableId = contextTrackableClass?.find(
    (trackable) => trackable.model?.toLowerCase() === "assetversion",
  )?.id;
  const appliedFilter = useSelector((state) =>
    selectAppliedFilterForTrackable(state, assetVersionTrackableId),
  );
  const appliedFilterIds = appliedFilter?.id != null ? [appliedFilter.id] : [];
  const appliedFilterKey = appliedFilter
    ? `${appliedFilter.id}:${JSON.stringify(appliedFilter.filters ?? [])}`
    : "";

  function handleFilterModalState() {
    setIsFilterModalOpen(!isFilterModalOpen);
  }

  const decodedURL = decodeURIComponent(
    escape(window.atob(history.location.search.substring(1))),
  );
  const searchParams = new URLSearchParams(decodedURL);
  let scrollTimer = null;
  useEffect(() => {
    fetchAssetVersion();
    fetchTrackableClass();
    setVersionFromURL(searchParams.get("versionId") || "");
    setCommentId(searchParams.get("commentId" || ""));
    setAssetVersionFilteredStatus(searchParams.get("status") || "");
    setSortByDefault(searchParams.get("sortBy") || "A-Z");

    var scrollStored = JSON.parse(localStorage.getItem("scroll"));
    if (scrollStored) {
      setScrollValue(scrollStored.assetVersion);
    } else {
      const scrollData = {
        asset: "0",
        assetVersion: "0",
        sequence: "0",
        shots: "0",
        shotVersion: "0",
      };
      localStorage.setItem("scroll", JSON.stringify(scrollData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      props.params.projectId ||
      props.params.assetID ||
      filterValues?.status ||
      filterValues?.task ||
      refreshCounter ||
      updateOnPageChange
    )
      fetchFilteredAssetVersion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    appliedFilterKey,
    props.params.projectId ||
      props.params.assetID ||
      assetVersionFilteredStatus,
    currentPage,
    updateOnPageChange,
    refreshCounter,
  ]);

  useEffect(() => {
    assetVersionList &&
      versionFromURL &&
      openVersionModalFromURL(versionFromURL);
  }, [versionFromURL, assetVersionList]);

  useEffect(() => {
    if (assetVersionList && assetVersionList.count !== 0) {
      const fields = mapFieldsFromConfig(
        assetVersionList.fields_config,
        assetVersionList.custom_fields,
        assetVersionList.default_fields,
      );
      setAllFieldsConfig(fields);
    }
    assetVersionList?.results &&
      searchParams.get("sortBy") &&
      handleSubmitSort(searchParams.get("sortBy"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetVersionList]);

  const fetchAssetVersion = async () => {
    const assetversion = {
      url: "web/assetversion/list/",
      data: {
        project_id: props.params.projectId,
        asset_id: props.params.assetID,
      },
    };
    try {
      const assetVersionRes = await fpostBFF(assetversion);
      if (
        searchParams.get("status") === null ||
        searchParams.get("status") === ""
      ) {
        setStatusList(assetVersionRes.data.status_list.results);
        setIsLoaded(true);
      }
      setAssetVersionStats((prevData) => ({
        ...prevData,
        visibleCount: assetVersionRes.data.assetversion_list.count,
      }));
      setTaskList(assetVersionRes?.data?.tasks_list?.results);
      setParentAsset(assetVersionRes.data.asset_details);
      setAllUsersName(
        assetVersionRes.data.project_users.results.map((el) => {
          const data = {
            name: el.first_name + " " + el.last_name,
            id: el.id,
          };
          return data;
        }),
      );
    } catch (error) {
      console.log(error);
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
      setIsLoaded(true);
    }
  };

  const updateRefreshCounter = () => {
    setRefreshCounter(refreshCounter + 1);
  };

  const handlePageChange = (pageNo) => {
    setCurrentPage(pageNo);
    setUpdateOnPageChange(updateOnPageChange + 1);
  };

  const updateCommentsRefreshCounter = () => {
    setCommentsRefreshCounter(commentsRefreshCounter + 1);
  };

  const fetchFilteredAssetVersion = async () => {
    let url = `trackables/asset-version/v2/?project=${props.params.projectId}&asset=${props.params.assetID}&page=${currentPage}`;
    if (filterValues.status) {
      url += `&status=${filterValues.status}`;
    }
    if (filterValues.task) {
      url += `&task=${filterValues.task}`;
    }
    if (sortByDefault) {
      url += `&sortBy=${sortByDefault}`;
    }
    try {
      appliedFilterIds.forEach((filterId) => {
        url += `&filter=${filterId}`;
      });
      const res = await fget({ url });
      setAssetVersionList(res.data);
      setIsLoaded(true);
      setIsNewPageLoading(false);
      history.push("?" + btoa(unescape(encodeURIComponent(url.split("?")[1]))));
    } catch (error) {
      setIsNewPageLoading(false);
      console.error("Error loading filtered asset versions", error);
    }
  };

  const fetchTrackableClass = async () => {
    try {
      const trackableClasses = await fget({
        url: "trackables/trackable-classes/",
      });
      setTrackableClass(trackableClasses.data);
      if (trackableClasses.data) {
        const taskClassId = trackableClasses.data.find(
          (eachvalue) => eachvalue.model === "task",
        );
        if (taskClassId.id) {
          await fetchTaskStatusList(taskClassId.id);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  async function fetchTaskStatusList(taskClassId) {
    try {
      const taskStatusList = await fget({
        url: `trackables/status-list/${taskClassId}/?project=${props.params.projectId}`,
      });
      if (taskStatusList.data) {
        setTaskStatusList(StatusRearrange(taskStatusList.data.results));
      }
    } catch (error) {}
  }

  function handleBackButton() {
    const newRoute = history.location.pathname
      .split("/")
      .slice(0, -2)
      .join("/");
    history.replace(newRoute);
  }

  function handleNewAssetVersionModalState() {
    setNewAssetVersionModalOpen(!isNewAssetVerisonModalOpen);
  }

  const handleAssetToggler = () => {
    setIsAssetTogglerOn(!isAssetTogglerOn);
  };

  //to open version modal by fetching id from the url
  const openVersionModalFromURL = (verId) => {
    handleAssetDetailModalState(
      assetVersionList?.results?.filter((x) => x.id === parseInt(verId))[0],
    );
  };

  function handleAssetDetailModalState(shotVer) {
    searchParams.set("versionId", `${shotVer.id}`);
    history.push(
      "?" + btoa(unescape(encodeURIComponent(searchParams.toString()))),
    );

    setSelectedAssetVersion(shotVer);
    setAssetDetailModalOpen(true);
    document.title = shotVer.name;
  }

  //Function to sort AssetVersion
  function handleSubmitSort(sortBy) {
    searchParams.set("sortBy", `${sortBy}`);
    history.push(
      "?" + btoa(unescape(encodeURIComponent(searchParams.toString()))),
    );
    switch (sortBy) {
      case "A-Z":
        assetVersionList?.results?.sort((a, b) => a.name.localeCompare(b.name));
        setSortByDefault("A-Z");
        break;
      case "Z-A":
        assetVersionList?.results?.sort((a, b) => b.name.localeCompare(a.name));
        setSortByDefault("Z-A");
        break;
      case "LatestModified":
        assetVersionList?.results?.sort(function (a, b) {
          var dateA = new Date(a.updated_at),
            dateB = new Date(b.updated_at);
          return dateB - dateA;
        });
        setSortByDefault("LatestModified");
        break;
      case "LastModified":
        assetVersionList?.results?.sort(function (a, b) {
          var dateA = new Date(a.updated_at),
            dateB = new Date(b.updated_at);
          return dateA - dateB;
        });
        setSortByDefault("LastModified");
        break;
      case "DateCreated":
        assetVersionList?.results?.sort(function (a, b) {
          var dateA = new Date(a.created_at),
            dateB = new Date(b.created_at);
          return dateA - dateB;
        });
        setSortByDefault("DateCreated");
        break;
      default:
        return assetVersionList?.results;
    }
  }

  const handleUpdatedFileForParent = (file) => {
    setUpdatedFileForParent(file);
    setUpdateParentAssetModalOpen(true);
  };

  const updateParentAssetThumbnail = async () => {
    let formdata = new FormData();
    formdata.append("name", parentAsset ? parentAsset.name : "");
    updatedFileForParent &&
      formdata.append("file_name", updatedFileForParent.name);
    formdata.append("project", props.params.projectId);
    formdata.append(
      "status",
      parentAsset && parentAsset.status ? parentAsset.status.id : "",
    );
    formdata.append(
      "type",
      parentAsset && parentAsset.type ? parentAsset.type : "",
    );

    let updatedAsset = {
      url: `trackables/asset/${props.params.assetID}/`,
      data: formdata,
    };

    try {
      const updateParentRes = await fpatch(updatedAsset);
      if (updateParentRes.status === 200 || 201) {
        getSignedUrl(updateParentRes.data.id);
      }
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
      setUpdateParentAssetModalOpen(false);
    }
  };

  const getSignedUrl = async (newId) => {
    try {
      const uploadUrl = await fget({
        url: `trackables/asset/${newId}/upload`,
      });
      if (uploadUrl.status === 200) {
        await uploadFile({
          url: uploadUrl.data?.signed_url,
          data: updatedFileForParent,
        }).then(() => {
          fget({
            url: `trackables/asset/${newId}/thumbnail`,
          });
          setSnackValue({
            isOpen: true,
            message: `SuccessFully updated thumbnail for parent asset ${parentAsset.name}`,
            isError: false,
          });
          setUpdateParentAssetModalOpen(false);
        });
      }
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
      setUpdateParentAssetModalOpen(false);
    }
  };

  const fetchFile = async () => {
    const fetchFileRes = await fget({
      url: `trackables/assetversion/${selectedAssetVersion?.id}/file`,
    });
    return fetchFileRes.data.signed_url;
  };

  const fetchComments = async () => {
    let url = `trackables/trackable-comment/?version_id=${
      selectedAssetVersion?.id
    }&version_type=${"assetversion"}&page=${commentsPageNo}&ordering=${commentFilter}`;

    const commentsRes = await fget({
      url: url,
    });
    return {
      comments: commentsRes.data.results.reverse(),
      isNextAvailable: commentsRes?.data?.next ? true : false,
    };
  };

  const handleStatusChange = async (e) => {
    let formdata = new FormData();

    formdata.append("status", e.target.value);
    let editedVersion = {
      url: `trackables/asset-version/${selectedAssetVersion?.id}/`,
      data: formdata,
    };

    try {
      await fpatch(editedVersion);
      setSnackValue({
        isOpen: true,
        message: `SuccessFully changed status`,
        isError: false,
      });
      updateRefreshCounter();
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  let assetVersionClass = trackableClass.find(
    (el) => el.model == "assetversion",
  );

  // fetch tasks of the current trackable
  const fetchTasks = async () => {
    let url = `trackables/task/?project=${props.params.projectId}&linked=${props.params.assetID}`;

    try {
      const taskListRes = await fget({
        url: url,
      });
      setTaskList(taskListRes.data.results);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async ({
    description,
    mentions,
    repliedTo,
    attachmentImage,
    timestamp,
  }) => {
    const formData = new FormData();
    formData.append("description", description);
    formData.append("trackable", props.params.assetID);
    formData.append("version_id", selectedAssetVersion?.id);
    formData.append("version_type", assetVersionClass.id || 0);
    formData.append("timestamp", timestamp || 0);
    mentions.forEach((mention) => {
      formData.append(`mentions`, mention);
    });

    if (repliedTo) formData.append("replied_to", repliedTo.id);

    if (attachmentImage) {
      const blob = await fetch(attachmentImage).then((res) => res.blob());
      const file = new File([blob], "commentImage.jpg", { type: "image/jpg" });
      formData.append("attachment", file);
    }

    let newComment = {
      url: "trackables/trackable-comment/",
      data: formData,
    };
    // mentionsRef.current.reset();
    try {
      await fpost(newComment);
      return newComment;
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const editComment = async (commentId, description, timestamp) => {
    const formData = new FormData();
    formData.append("description", description);
    formData.append("trackable", props.params.assetID);
    formData.append("version_id", selectedAssetVersion?.id);
    formData.append("version_type", assetVersionClass.id || 0);
    formData.append("timestamp", timestamp || 0);
    let editedComment = {
      url: `trackables/trackable-comment/${commentId}/`,
      data: formData,
    };
    try {
      await fpatch(editedComment);
      return editedComment;
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const handleDragFile = (e) => {
    setDragScreen(true);
    if (e.type == "drop") {
      //if we drop file , removing drag zone screen
      setDragScreen(false);
    }
    if (e.type == "dragleave") {
      //if we leave the drag file , removing drag zone screen
      if (dragFileEnterModal) {
        setDragScreen(true);
      } else {
        setDragScreen(false);
      }
    }
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragScreen = (el) => {
    setDragScreen(el);
  };

  const handleTableScroll = (e) => {
    if (scrollTimer !== null) clearTimeout(scrollTimer);

    scrollTimer = setTimeout(() => {
      searchParams.set("scroll", `${e.target.scrollTop}`);
      history.push(
        "?" + btoa(unescape(encodeURIComponent(searchParams.toString()))),
      );
      let scrollStored = JSON.parse(localStorage.getItem("scroll"));
      scrollStored.assetVersion = e.target.scrollTop;
      localStorage.setItem("scroll", JSON.stringify(scrollStored));
    }, 700);
  };

  const getAssetVersionStats = async () => {
    try {
      const assetVersionRes = await fget({
        url: `trackables/trackable-count/assetversion/${props.params.assetID}/`,
      });
      setAssetVersionStats((prevData) => ({
        ...prevData,
        total: assetVersionRes.data.instances,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAssetVersionStats();
  }, [refreshCounter]);

  const fetchAllAssetVersionData = async () => {
    const PAGE_SIZE = 50;
    const firstRes = await fget({
      url: `trackables/asset-version/?page=1&asset=${props.params.assetID}&status=${filterValues.status}&task=${filterValues.task}`,
    });
    const totalCount = firstRes.data.count;
    const totalPages = Math.ceil(totalCount / PAGE_SIZE);

    if (totalPages <= 1) {
      return firstRes.data.results;
    }

    const remainingPromises = Array.from({ length: totalPages - 1 }, (_, i) =>
      fget({
        url: `trackables/asset-version/?page=${i + 2}&asset=${props.params.assetID}&status=${filterValues.status}&task=${filterValues.task}`,
      }),
    );
    const remainingResults = await Promise.all(remainingPromises);

    return [
      ...firstRes.data.results,
      ...remainingResults.flatMap((res) => res.data.results),
    ];
  };

  const createAssetVersionInBulk = async (
    tableData,
    columnMappings,
    trackableType,
    defaultFields = [],
  ) => {
    const validApiFields = new Set(defaultFields.map((f) => f.name));
    const assetVersions = tableData.map((row) =>
      Object.fromEntries(
        Object.entries(columnMappings)
          .filter(
            ([, apiField]) =>
              apiField && apiField !== "none" && validApiFields.has(apiField),
          )
          .map(([csvHeader, apiField]) => [apiField, row[csvHeader]]),
      ),
    );
    assetVersions.forEach((assetVersion) => {
      assetVersion.project = props.params.projectId;
      assetVersion.asset = props.params.assetID;
    });
    try {
      const res = await fpost({
        url: `trackables/asset-version/v2/`,
        data: assetVersions,
      });
      if (res.status === 200 || res.status === 201) {
        setSnackValue({
          isOpen: true,
          message: "Asset versions imported successfully",
          isError: false,
        });
        updateRefreshCounter();
        return true;
      }
      return false;
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: error.response.data.detail || "Error importing asset versions",
        isError: true,
      });
      console.log(error);
      return false;
    }
  };

  const getAssetVersionExtraQuery = useCallback(
    () => `&asset=${props.params.assetID}`,
    [props.params.assetID],
  );

  return (
    <div
      className={classes.root}
      onDragEnter={(e) => handleDragFile(e)}
      onDrop={(e) => handleDragFile(e)}
      onDragLeave={(e) => handleDragFile(e)}
      onDragOver={(e) => handleDragFile(e)}
    >
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackValue.isOpen}
        autoHideDuration={2000}
        onClose={() => setSnackValue({ isOpen: false, message: "" })}
      >
        <Alert severity={snackValue.isError === false ? "success" : "warning"}>
          {snackValue.message}
        </Alert>
      </Snackbar>
      <AssetVersionsTools
        handleFilterModalState={handleFilterModalState}
        status={statusList}
        handleBackButton={handleBackButton}
        openNewAssetVerisonModal={handleNewAssetVersionModalState}
        handleStatusChange={(value) => {
          setAssetVersionFilteredStatus(value);
          if (value === "") {
            history.replace(history.location.pathname);
            window.location.reload();
          }
        }}
        filterValues={filterValues}
        parentAsset={parentAsset}
        handleAssetToggler={handleAssetToggler}
        projectId={props.params.projectId}
        assetID={props.params.assetID}
        onSubmit={handleSubmitSort}
        defaultValue={sortByDefault}
        filterButtonActive={filterButtonActive}
        assetVersionStats={assetVersionStats}
        handleOpenTimelineModal={() => setIsTimeLineModalOpen(true)}
        handleOpenExportModal={() => setIsExportModalOpen(true)}
        handleOpenBulkImportModal={() => setOpenBulkImportModal(true)}
        isToggleView={isToggleView}
        handleToggleView={() => setIsToggleView(!isToggleView)}
      />
      {!isLoaded && <Loader />}
      {isLoaded && assetVersionList && assetVersionList.count === 0 && (
        <NoData />
      )}
      {isLoaded && assetVersionList && assetVersionList.count > 0 && (
        <>
          {isToggleView ? (
            <AssetVersionCustomTable
              assetVersionList={assetVersionList}
              projectId={props.params.projectId}
              statusList={statusList}
              updateRefreshCounter={updateRefreshCounter}
              setSnackValue={setSnackValue}
              allFieldsConfig={allFieldsConfig}
              handleAssetDetailModalState={handleAssetDetailModalState}
              taskList={taskList}
              fetchTasks={fetchTasks}
              dragScreen={dragScreen}
              handleDragScreen={handleDragScreen}
              setDragFileEnterModal={setDragFileEnterModal}
            />
          ) : (
            <AssetVersionDefaultTable
              assetVersionList={assetVersionList}
              tableRef={tableRef}
              scrollValue={scrollValue}
              taskList={taskList}
              fetchTasks={fetchTasks}
              handleAssetDetailModalState={handleAssetDetailModalState}
              projectId={props.params.projectId}
              assetID={props.params.assetID}
              statusList={statusList}
              isAssetTogglerOn={isAssetTogglerOn}
              updateRefreshCounter={updateRefreshCounter}
              dragScreen={dragScreen}
              handleDragScreen={handleDragScreen}
              setDragFileEnterModal={setDragFileEnterModal}
              handleTableScroll={handleTableScroll}
            />
          )}
          {assetVersionList.count > 50 && (
            <footer style={{ bottom: "0", height: "100%" }}>
              <CustomPagination
                handlePageChange={handlePageChange}
                currentPage={currentPage}
                totalItem={assetVersionList?.count}
                totalPage={Math.ceil(assetVersionList?.count / 50)}
                setIsNewPageLoading={setIsNewPageLoading}
                trackable="Asset versions"
              />
            </footer>
          )}
        </>
      )}
      <Modal className={classes.assetsPageModals} open={isNewPageLoading}>
        <NewDataLoadingLoader trackable="Asset versions" />
      </Modal>

      <Modal
        open={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        className={classes.assetsPageModals}
      >
        <VersionFilterModal
          updateList={() => fetchFilteredAssetVersion()}
          closeModal={handleFilterModalState}
          taskList={taskList}
          status={statusList}
          filterValues={filterValues}
          setFilterValues={setFilterValues}
          setFilterButtonActive={setFilterButtonActive}
        />
      </Modal>

      <Modal
        className={classes.assetsPageModals}
        open={isNewAssetVerisonModalOpen}
        onClose={() => setNewAssetVersionModalOpen(false)}
      >
        <AssetVersionNewVersionModal
          handleUpdatedFileForParent={handleUpdatedFileForParent}
          projectId={props.params.projectId}
          assetID={props.params.assetID}
          status={statusList}
          trackableClassList={trackableClass}
          handleNewAssetVersionModalState={handleNewAssetVersionModalState}
          updateRefreshCounter={updateRefreshCounter}
          dragScreen={dragScreen}
          handleDragScreen={handleDragScreen}
          setDragFileEnterModal={setDragFileEnterModal}
          taskList={taskList}
          fetchTasks={fetchTasks}
          customFields={assetVersionList?.custom_fields}
        />
      </Modal>

      <Modal
        className={classes.assetsPageModals}
        open={isUpdateParentAssetModalOpen}
        onClose={() => setUpdateParentAssetModalOpen(false)}
      >
        <UpdateParentAssetOrShootThumbnailModal
          versionType="Asset"
          parent={parentAsset}
          handleSubmit={() => {
            updateParentAssetThumbnail();
          }}
          closeUpdateParentModal={() => setUpdateParentAssetModalOpen(false)}
        />
      </Modal>

      <Modal
        className={classes.assetVersionPageModals}
        open={isAssetDetailModalOpen}
        onClose={() => {
          setAssetDetailModalOpen(false);
          searchParams.set("versionId", "");
          setVersionFromURL("");
          history.push(
            "?" + btoa(unescape(encodeURIComponent(searchParams.toString()))),
          );
          document.title = "MovieColab";
        }}
      >
        <VersionViewerOverview
          commentsPageNo={commentsPageNo}
          setCommentsPageNo={setCommentsPageNo}
          versionList={assetVersionList}
          selectedVersion={selectedAssetVersion}
          setSelectedVersion={setSelectedAssetVersion}
          projectId={props.params.projectId}
          fetchFile={fetchFile}
          fetchComments={fetchComments}
          parentTrackable={parentAsset}
          closeModal={() => {
            setAssetDetailModalOpen(false);
            setVersionFromURL("");
            searchParams.set("versionId", "");
            history.push(
              "?" + btoa(unescape(encodeURIComponent(searchParams.toString()))),
            );
            document.title = "MovieColab";
          }}
          handleStatusChange={handleStatusChange}
          status={statusList}
          updateRefreshCounter={updateRefreshCounter}
          canvasModal={canvasModal}
          setCanvasModal={setCanvasModal}
          setImageRef={setImageRef}
          setScreenshot={setScreenshot}
          screenshot={screenshot}
          allUsersName={allUsersName}
          handleSubmit={handleSubmit}
          version_type={assetVersionClass ? assetVersionClass.id : 0}
          assetId={props.params.assetID}
          setPlayerProgress={setPlayerProgress}
          setIsOpenFullscreenViewer={setIsOpenFullscreenViewer}
          setFileForFullscreenViewer={setFileForFullscreenViewer}
          commentsRefreshCounter={commentsRefreshCounter}
          taskStatusList={taskStatusList}
          commentId={commentId}
          commentFilter={commentFilter}
          changeCommentFilter={setCommentFilter}
          editComment={editComment}
        />
      </Modal>

      <Modal
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        open={canvasModal}
      >
        <CanvasFrame
          closeModal={() => setCanvasModal(false)}
          imageRef={imageRef}
          image={screenshot}
          assetID={props.params.assetID}
          toggle={() => setCanvasModal(!canvasModal)}
          fetchComments={fetchComments}
          version_id={selectedAssetVersion?.id}
          version_type={assetVersionClass ? assetVersionClass.id : 0}
          users={allUsersName}
          progress={playerProgress}
          updateCommentsRefreshCounter={updateCommentsRefreshCounter}
        />
      </Modal>

      <Modal
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        BackdropProps={{
          style: { backgroundColor: "black", opacity: "0.7" },
        }}
        open={isOpenFullscreenViewer}
        onClose={() => setIsOpenFullscreenViewer(false)}
      >
        <div
          style={{
            borderRadius: "30px",
            height: "90%",
            width: "90%",
            position: "relative",
            outline: "none",
          }}
        >
          {fileForFullscreenViewer ? (
            <img
              alt="full screen"
              src={fileForFullscreenViewer}
              style={{
                borderRadius: "30px",
                height: "100%",
                width: "100%",
              }}
            />
          ) : (
            "No File Found"
          )}
          <X
            className={classes.closeFullScreen}
            onClick={() => setIsOpenFullscreenViewer(false)}
          />
        </div>
      </Modal>
      {isTimeLineModalOpen && (
        <Slide direction="left" in={isTimeLineModalOpen}>
          <Box
            style={{
              display: isTimeLineModalOpen ? "block" : "none",
              top: "157px",
              height: `calc(100vh - 157px)`,
            }}
            className={classes.floatingDiv}
          >
            <AssetAndShotVersionTimeline
              type="asset"
              id={props.params.assetID}
              parent={parentAsset}
              handleClose={() => setIsTimeLineModalOpen(false)}
            />
          </Box>
        </Slide>
      )}
      <Modal
        className={classes.assetsPageModals}
        open={openBulkImportModal}
        onClose={() => setOpenBulkImportModal(false)}
      >
        <CSVImportModal
          createInBulk={createAssetVersionInBulk}
          trackableType="assetversion"
          closeModal={() => setOpenBulkImportModal(false)}
          projectId={props.params.projectId}
          requiredFields={["name"]}
        />
      </Modal>
      <Modal
        className={classes.assetsPageModals}
        open={isExportModalOpen}
        onClose={() => {
          setIsExportModalOpen(false);
        }}
      >
        <ExportModal
          headersList={[
            "Asset Version Name",
            "Added On",
            "Status",
            "Created By",
            "Task Related",
            "Comments",
          ]}
          valuesList={[
            { name: "name", type: "string" },
            { name: "updated_at", type: "date" },
            { name: "status", type: "object", key: "name" },
            {
              name: "created_by",
              type: "object",
              key: "first_name",
              key2: "last_name",
            },
            { name: "task", type: "object", key: "name" },
            { name: "related_comments_number", type: "number" },
          ]}
          fetchAllData={fetchAllAssetVersionData}
          handleClose={() => setIsExportModalOpen(false)}
        />
      </Modal>
    </div>
  );
}

export default AssetVersionsOverview;
